const ITEMS = [
  "Executive Search",
  "Retained Search",
  "Permanent Hiring",
  "Contract Hiring",
  "HR Advisory",
  "Startup HR",
  "Training",
  "RoleSense™ Intelligence",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="overflow-hidden border-y border-line bg-paper-deep py-5" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="whitespace-nowrap font-serif text-lg italic text-ink-muted sm:text-xl">
                  {item}
                </span>
                <span className="mx-8 inline-block h-1.5 w-1.5 rotate-45 bg-gold" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
